/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyFuelCardSerializer
 */
export interface ReadOnlyFuelCardSerializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    client?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCardSerializer
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCardSerializer
     */
    holder?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    fuelCompany?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyFuelCardSerializer
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyFuelCardSerializer
     */
    startTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyFuelCardSerializer
     */
    endTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    limitAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    limitDuration?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCardSerializer
     */
    status?: ReadOnlyFuelCardSerializerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCardSerializer
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    monitoredObject?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCardSerializer
     */
    user?: number | null;
}

export function ReadOnlyFuelCardSerializerFromJSON(json: any): ReadOnlyFuelCardSerializer {
    return ReadOnlyFuelCardSerializerFromJSONTyped(json, false);
}

export function ReadOnlyFuelCardSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyFuelCardSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'client': !exists(json, 'client') ? undefined : json['client'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'holder': !exists(json, 'holder') ? undefined : json['holder'],
        'fuelCompany': !exists(json, 'fuel_company') ? undefined : json['fuel_company'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
        'startTime': !exists(json, 'start_time') ? undefined : (json['start_time'] === null ? null : new Date(json['start_time'])),
        'endTime': !exists(json, 'end_time') ? undefined : (json['end_time'] === null ? null : new Date(json['end_time'])),
        'limitAmount': !exists(json, 'limit_amount') ? undefined : json['limit_amount'],
        'limitDuration': !exists(json, 'limit_duration') ? undefined : json['limit_duration'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'monitoredObject': !exists(json, 'monitored_object') ? undefined : json['monitored_object'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function ReadOnlyFuelCardSerializerToJSON(value?: ReadOnlyFuelCardSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client': value.client,
        'number': value.number,
        'holder': value.holder,
        'fuel_company': value.fuelCompany,
        'expiration_date': value.expirationDate === undefined ? undefined : (value.expirationDate === null ? null : value.expirationDate.toISOString().substr(0,10)),
        'start_time': value.startTime === undefined ? undefined : (value.startTime === null ? null : value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime === null ? null : value.endTime.toISOString()),
        'limit_amount': value.limitAmount,
        'limit_duration': value.limitDuration,
        'status': value.status,
        'note': value.note,
        'monitored_object': value.monitoredObject,
        'user': value.user,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyFuelCardSerializerStatusEnum {
    InProduction = 'in_production',
    Sent = 'sent',
    WaitingActivation = 'waiting_activation',
    Active = 'active',
    Restricted = 'restricted',
    Blocked = 'blocked',
    Expired = 'expired',
    Cancelled = 'cancelled'
}


